import { Component, OnInit } from '@angular/core';
import {IntegrationService} from "@cx-services/integration.service";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {environment} from "@cx-env/environment";

const DEFAULT_SUKHA_TNC_URL = 'https://bmri.id/sukhatncxaddtix';

@Component({
    selector: 'cx-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [NgIf, RouterLink, TranslateModule]
})
export class FooterComponent implements OnInit {
  uri: string = ''
  constructor(
    public iS: IntegrationService,
    private route: ActivatedRoute,
  ) {
    this.uri = this.route.snapshot.params['uri'] || '';
  }

  ngOnInit(): void {
    console.log('uri',this.uri)
  }

  get isIiccs(){
    // return this.uri === 'test-custom-e-ticket-testing-baru'
    return this.uri === 'the-3rd-iiccs-forum-2025'
  }

  get yearNow(){
    return new Date().getFullYear();
  }

  get sukhaTncUrl(){
    const path = window.location.pathname;
    const match = environment.sukhaTnc?.find((t) => path.includes(t.uri));
    return match ? match.url : DEFAULT_SUKHA_TNC_URL;
  }

}
